import Swal from "sweetalert2";
import styled from 'styled-components';
import EditIcon from 'mdi-react/EditIcon';
import { Spinner } from 'react-bootstrap';
import DeleteIcon from 'mdi-react/DeleteIcon';
import React, { useState, useEffect } from 'react';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { paddingLeft, paddingRight } from '@/utils/directions';
import ReactTableBase from '@/shared/components/table/ReactTableBase';
import { colorAdditional, colorGreenHover, colorAccent } from '@/utils/palette';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';

const CartTableButton = styled.button`
  background: transparent;
  border: none;
  line-height: 14px;
  ${paddingLeft}: 20px;
  ${paddingRight}: 0;
  padding-top: 0;
  padding-bottom: 0;
  color: ${colorAdditional};
  cursor: pointer;
  transition: all 0.3s;

  svg {
    height: 20px;
    width: 20px;
    fill: ${colorAdditional};
    transition: all 0.3s;
  }

  svg:hover {
    fill: ${colorGreenHover};
  }

  .orange-hover:hover {
    fill: #e9c886;
  }

  .red-hover:hover {
    fill: #e98686;
  }
`;

const TableSpinner = styled(Spinner)`
  color: ${colorAccent};
`;

const InstrumentsList = (props) => {
    const [showLoader, setShowLoader] = useState(true);
    const [instrumentsList, setInstrumentsList] = useState({ tableHeaderData: [], tableRowsData: [] });
    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false,
        withPagination: false,
        withSearchEngine: true,
        placeholder: 'Search...',
    };

    const handleEdit = (instrument) => {
        props.setSelectedInstrument(instrument)
    }

    const handleDelete = (instrument) => {
        Swal.fire({
            title: 'Warning!',
            text: `Do you want to delete the instrument ${instrument.name}?`,
            icon: 'warning',
            confirmButtonText: 'Yes!',
            cancelButtonText: 'No!',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                AdminInterface.instance.deleteInstrument(instrument.id).then(() => {
                    withReactContent(Swal).fire({
                        title: "Success",
                        html: "Instrument is deleted!",
                    });
                    props.setListRequiresReload(true);
                }).catch((error) => {
                    withReactContent(Swal).fire({
                        title: "Error",
                        html: error.response?.data?.detail,
                    });
                })
            }
        });
    }

    const GetInstruments = () => {
        setShowLoader(true);
        AdminInterface.instance.getInstruments().then((response) => {
            const columns = [
                {
                    accessor: 'id',
                    Header: 'Id',
                },
                {
                    accessor: 'name',
                    Header: 'Name',
                },
                {
                    accessor: 'edit',
                    Header: 'Edit',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                },
                {
                    accessor: 'delete',
                    Header: 'Delete',
                    disableGlobalFilter: true,
                    disableSortBy: true,
                }
            ];
            const data = [];
            response.data.forEach(instrument => {
                data.push({
                    id: instrument.id,
                    name: instrument.name,
                    edit: <CartTableButton type="button" onClick={() => handleEdit(instrument)}><EditIcon className="orange-hover"/></CartTableButton>,
                    delete: <CartTableButton type="button" onClick={() => handleDelete(instrument)}><DeleteIcon className="red-hover"/></CartTableButton>,
                });
            });

            setInstrumentsList({ tableHeaderData: columns, tableRowsData: data });
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        }).finally(() => {
            setShowLoader(false);
            props.setListRequiresReload(false);
        });
    }

    useEffect(() => {
        GetInstruments();
    }, [props.listRequiresReload]);

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>Instruments List</CardTitle>
                </CardTitleWrap>
                {
                    !showLoader &&
                    <ReactTableBase columns={instrumentsList.tableHeaderData} data={instrumentsList.tableRowsData} tableConfig={tableConfig} />
                }
                {showLoader && (<div className="text-center"><TableSpinner animation="border" /></div>)}
            </CardBody>
        </Card>
    );
};

export default InstrumentsList;